import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "m6 18-2.3 2.3q-.476.476-1.088.213-.613-.262-.612-.938V4q0-.824.588-1.412A1.93 1.93 0 0 1 4 2h16q.825 0 1.413.588T22 4v12q0 .825-.587 1.413A1.92 1.92 0 0 1 20 18zm-.85-2H20V4H4v13.125z"
    }, null, -1)
  ]))]))
}
export default { render: render }